var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 11,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#157F5B",
  d: "M5.745 10.458a1.534 1.534 0 0 1-2.161 0l-3.15-3.18a1.506 1.506 0 0 1 0-2.115l.015-.016a1.497 1.497 0 0 1 2.13 0l2.085 2.085L11.405.445a1.516 1.516 0 0 1 2.146 0l.015.015a1.506 1.506 0 0 1 0 2.116z"
})));
export { SvgCheckedIcon as ReactComponent };
export default __webpack_public_path__ + "91f0be1a12ef4cde3edb849c4a2d8020.svg";